function cov_1an10xog32() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/StarFilled.tsx";
  var hash = "c33de262e1d16d0663af48db55543adc468b26c4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/StarFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 51
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c33de262e1d16d0663af48db55543adc468b26c4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1an10xog32 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1an10xog32();
const Icon = (cov_1an10xog32().s[0]++, {
  name: 'star-filled',
  svg: "<path d=\"M15.3505 8.14162L21.3691 9.05763C21.5052 9.07876 21.633 9.13923 21.738 9.23226C21.8431 9.32528 21.9213 9.44716 21.9638 9.58418C22.0063 9.7212 22.0115 9.86791 21.9787 10.0078C21.9459 10.1477 21.8765 10.2753 21.7782 10.3762L17.4257 14.8194L18.4534 21.0947C18.4769 21.2372 18.4616 21.3838 18.4095 21.5178C18.3574 21.6518 18.2705 21.7678 18.1587 21.8527C18.0468 21.9376 17.9144 21.988 17.7766 21.9981C17.6388 22.0082 17.501 21.9777 17.3789 21.9101L11.9986 18.9479L6.61593 21.9101C6.49382 21.9777 6.35603 22.0082 6.2182 21.9981C6.08038 21.988 5.94802 21.9376 5.83615 21.8527C5.72427 21.7678 5.63736 21.6518 5.58526 21.5178C5.53316 21.3838 5.51795 21.2372 5.54137 21.0947L6.56911 14.8194L2.22401 10.3787C2.12502 10.278 2.05495 10.1502 2.02173 10.0099C1.98851 9.86964 1.99346 9.72243 2.03604 9.58494C2.07862 9.44744 2.15712 9.32517 2.26264 9.23197C2.36817 9.13878 2.49651 9.0784 2.63313 9.05763L8.6517 8.14162L11.3332 2.43401C11.394 2.30382 11.4885 2.19412 11.6059 2.11739C11.7233 2.04066 11.859 2 11.9974 2C12.1358 2 12.2715 2.04066 12.3889 2.11739C12.5063 2.19412 12.6008 2.30382 12.6616 2.43401L15.3505 8.14162Z\" fill=\"currentColor\"/>"
});
export default Icon;